define('SEOImprovements.Home.View', [
    'Home.View',
    'underscore',
    'SC.Configuration'
], function SEOImprovementsHomeView(
    HomeView,
    _,
    Configuration
) {
    'use strict';

    _.extend(HomeView.prototype, {
        getMetaDescription: _.wrap(HomeView.prototype.getMetaDescription, function getMetaDescription(fn) {
            var ret = fn.apply(this, _.toArray(arguments).slice(1));
            return ret || Configuration.get('seo.siteDescription');
        }),
        getTitle: _.wrap(HomeView.prototype.getTitle, function getTitle(fn) {
            var ret = fn.apply(this, _.toArray(arguments).slice(1));
            return ret || Configuration.get('seo.siteTitle') || Configuration.get('siteSettings.displayName');
        })
    });
});
